import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

/** Same tab labels as the mobile Leave Overview screen. */
const TABS = [
  { label: "Leave Request", to: all_routes.LeaveManagement.list },
  { label: "Calendar", to: all_routes.LeaveManagement.calendar },
  { label: "Team Calendar", to: all_routes.LeaveManagement.teamCalendar },
  { label: "Time Accounts", to: all_routes.LeaveManagement.timeAccounts },
];

const LeaveModuleTabs: React.FC = () => {
  const location = useLocation();
  return (
    <div className="leave-module-tabs" role="tablist">
      {TABS.map((tab) => (
        <NavLink
          key={tab.label}
          to={tab.to}
          state={location.state}
          end
          role="tab"
          className={({ isActive }) =>
            `leave-module-tab${isActive ? " active" : ""}`
          }
        >
          {tab.label}
        </NavLink>
      ))}
      <style>{`
        .leave-module-tabs {
          display: flex;
          flex-wrap: wrap;
          gap: 8px 18px;
          background: #fff;
          border-radius: 12px;
          padding: 10px 16px 0;
          margin-bottom: 16px;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
        }
        .leave-module-tab {
          position: relative;
          padding: 8px 2px 12px;
          color: #6b7280;
          font-weight: 600;
          font-size: 14px;
          text-decoration: none;
          border-bottom: 3px solid transparent;
        }
        .leave-module-tab:hover {
          color: #ab1f24;
        }
        .leave-module-tab.active {
          color: #ab1f24;
          border-bottom-color: #ab1f24;
        }
      `}</style>
    </div>
  );
};

export default LeaveModuleTabs;
